import styled from '@emotion/styled';

const Card = styled.div`
  background: white;
  border: 1px solid #B2ADA6;
`;

export default Card;
